import React, { useEffect, useState } from "react";
import { Chart, registerables } from "chart.js";
import Swal from "sweetalert2";

Chart.register(...registerables);

export const MembresiaCharts = ({ identificador, tipo = "bar" }) => {
  const [chartData, setChartData] = useState([]);

  //PETICION HTTP USEEFFECT
  useEffect(() => {
    const crearGrafica = (chart) => {
      console.log(chart);
      const ctx = document.getElementById(identificador);
      new Chart(ctx, {
        type: tipo,
        data: {
          labels: chart.label,
          datasets: [
            {
              label: "Membresias",
              data: chart.data,
              backgroundColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            xAxes: [
              {
                stacked: true,
              },
            ],
          },
        },
      });
    };

    async function getData() {
      const url = `${process.env.REACT_APP_MI_VARIABLE_DE_ENTORNO}/api/datos/chartsmembresia`;
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          "x-token": localStorage.getItem("token"),
        },
      });
      const respuesta = await resp.json();

      if (resp.ok) {
        crearGrafica(respuesta.charts);
        // Guardar los datos en estado para la tabla
        const tableData = respuesta.charts.label.map((label, index) => ({
          nombre: label,
          cantidad: respuesta.charts.data[index],
        }));
        setChartData(tableData);
      } else {
        if (respuesta.msg === undefined) {
          Swal.fire("Error", respuesta.errors[0].msg, "error");
        } else {
          Swal.fire("Error", respuesta.msg, "error");
        }
      }
    }
    getData();
  }, [identificador, tipo]);

  return (
    <div>
      <canvas id={identificador}></canvas>

      <div style={{ marginTop: "30px" }}>
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#e3f2fd",
            border: "1px solid #2196f3",
            borderRadius: "4px",
            padding: "8px 12px",
            marginBottom: "15px",
            fontSize: "13px",
            color: "#1565c0",
            fontWeight: "500",
          }}
        >
          <span style={{ marginRight: "6px" }}>ℹ️</span>
          Estos datos incluyen únicamente membresías vinculadas a contadores. No
          se consideran auxiliares ni clientes de cada contador.
        </div>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            backgroundColor: "#fff",
            borderRadius: "4px",
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#f5f5f5",
                borderBottom: "2px solid #e0e0e0",
              }}
            >
              <th
                style={{
                  padding: "12px 16px",
                  textAlign: "left",
                  fontWeight: "600",
                  color: "#333",
                  fontSize: "14px",
                }}
              >
                Plan / Membresía
              </th>
              <th
                style={{
                  padding: "12px 16px",
                  textAlign: "right",
                  fontWeight: "600",
                  color: "#333",
                  fontSize: "14px",
                }}
              >
                Cantidad de Registros
              </th>
            </tr>
          </thead>
          <tbody>
            {chartData.map((item, index) => (
              <tr
                key={index}
                style={{
                  borderBottom: "1px solid #f0f0f0",
                  transition: "background-color 0.2s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#fafafa")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                <td
                  style={{
                    padding: "12px 16px",
                    color: "#555",
                    fontSize: "14px",
                  }}
                >
                  {item.nombre}
                </td>
                <td
                  style={{
                    padding: "12px 16px",
                    textAlign: "right",
                    color: "#2196f3",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {item.cantidad}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
